import { useFetcherCSR } from '@/lib/useFetcherCSR';
import React, { useState } from 'react';
import NextImage from '../Image';
import Link from 'next/link';
import AuthenticityModal from '../order-details/AuthenticityModal';
import AuthenticityUpdateModal from '../order-details/AuthenticityUpdateModal';
import VerifyProductSkeleton from './VerifyProductSkeleton';
import { API_AUTHENTIC_USER_ORDER_HISTORY } from '@/constant/apiRout';

function VerifyProduct() {
  const { data, mutate, isLoading } = useFetcherCSR(
    API_AUTHENTIC_USER_ORDER_HISTORY
  );
  const [show, setShow] = useState<boolean>(false);
  const [showUpdate, setUpdateShow] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedOrderId, setSelectedOrderId] = useState<number>(0);
  const [selectedUpdateId, setSelectedUpdateId] = useState<number>(0);
  const handleOpenVerify = (id: number, orderId: number) => {
    setSelectedId(id);
    setSelectedOrderId(orderId);
    setShow(true);
  };
  const handleOpenVerifyUpdate = (id: number, orderId: number) => {
    setSelectedUpdateId(id);
    setSelectedOrderId(orderId);
    setUpdateShow(true);
  };

  if (isLoading) {
    return (
      <div className="order-details">
        <div className="order-details__card">
          <VerifyProductSkeleton count={4} />
        </div>
      </div>
    );
  }

  return (
    <div className="order-details">
      <div className="order-details__card">
        {data?.data?.length > 0 ? (
          <div className="order-details__items">
            {data?.data?.map((item: any) => (
              <div
                className="order-details__item d-flex flex-column flex-sm-row align-items-sm-center justify-content-between p-3 border rounded mb-3 gap-2 gap-sm-3"
                key={item.id}
              >
                {/* Image and Product Name (left side) */}
                <div className="d-flex align-items-center gap-3 flex-grow-1 w-100 w-sm-auto">
                  {/* Image container */}
                  <div
                    style={{
                      flexShrink: 0,
                      width: '80px',
                      height: '80px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    <NextImage
                      src={item?.small_pictures[0]?.url}
                      width={80}
                      height={80}
                      alt={item?.name}
                      className="w-100 h-100 object-fit-cover rounded"
                    />
                  </div>

                  {/* Product name - shows quantity on mobile */}
                  <div className="min-w-0">
                    <h6 className="mb-0 mb-sm-1 fw-medium ">
                      <Link href={`/product/${item?.slug}`}>
                        {item.product_name}
                      </Link>
                    </h6>
                    <span className="small text-secondary d-sm-none mb-2">
                      Qty: {item?.quantity} • {item?.price}
                    </span>
                    {!item?.is_authentic_review && (
                      <div className="ms-sm-3 flex-shrink-0 d-md-none mt-2">
                        <button
                          onClick={() =>
                            handleOpenVerify(item?.product_id, item?.order_id)
                          }
                          className="btn btn-success"
                        >
                          Verify product
                        </button>
                      </div>
                    )}
                    {item?.can_update_authentic_review && (
                      <div className="ms-sm-3 flex-shrink-0 d-md-none mt-2">
                        <button
                          onClick={() =>
                            handleOpenVerifyUpdate(item?.id, item?.order_id)
                          }
                          className="btn btn-danger"
                        >
                          Update Verify
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right side content (price and button) */}
                <div className="d-flex justify-content-between justify-content-sm-end align-items-center gap-3 w-100 w-sm-auto">
                  {/* Price - hidden on mobile (shown with name) */}
                  {!item?.is_authentic_review && (
                    <div className="ms-sm-3 flex-shrink-0 d-none d-md-block">
                      <button
                        onClick={() =>
                          handleOpenVerify(item?.product_id, item?.order_id)
                        }
                        className="btn btn-success"
                      >
                        Verify product
                      </button>
                    </div>
                  )}
                  {item?.can_update_authentic_review && (
                    <div className="ms-sm-3 flex-shrink-0 d-none d-md-block">
                      <button
                        onClick={() =>
                          handleOpenVerifyUpdate(item?.id, item?.order_id)
                        }
                        className="btn btn-danger"
                      >
                        Update Verify
                      </button>
                    </div>
                  )}
                  <div className="d-none d-sm-block text-end">
                    <h6 className="mb-0 fw-semibold text-dark">{item.price}</h6>
                    <span className="small text-secondary">
                      Qty: {item.quantity}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="order-details__items">
            <h4 className="fw-semibold text-center">No Products Found</h4>
          </div>
        )}
      </div>
      <AuthenticityModal
        show={show}
        setShow={setShow}
        mutate={mutate}
        orderId={selectedOrderId} // Pass the main order ID
        productId={selectedId}
      />
      <AuthenticityUpdateModal
        show={showUpdate}
        setShow={setUpdateShow}
        mutate={mutate}
        orderId={selectedOrderId} // Pass the main order ID
        productId={selectedUpdateId}
      />
    </div>
  );
}

export default VerifyProduct;
